import React, { Component } from "react";
import Select from "react-select";
import { SkyLightStateless } from 'react-skylight';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import _ from 'lodash';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";
import axios from 'axios';
import {
  ROOT_URL, //https://abc-scm.truckxi.com/api/
  isGFD, isVAK,
} from '../../../../actions/root_url';
import { InputField } from '../../inputField';
import Spinner from '../../../../components/Widgets/spinner';

const mergePOAPI = (poIds, data, success, failed) => {
  const route = isVAK ? 'vakker_merge_purchase_order' : 'merge_purchase_order'
  axios({
    method: 'POST',
    data,
    url: `${ROOT_URL}v1/purchase/${route}/${poIds} `,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
  }).then(res => {
    alert('SUCCESS!')
    success();
  }).catch(err => {
    failed();
    if (err.data) {
      alert(JSON.stringify(err.data))
    } else {
      alert(JSON.stringify(err));
    }
  });
}

const modalStyle = {
  width: '500px',
  height: '280px',
  marginLeft: '-10%',
}

const propTypes = {
}

const defaultProps = {
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonToolbar: {
    display: 'flex',
    justifyContent: 'space-evenly',
    width: '100%',
    marginTop: '40px',
  }
}

class POMerge extends Component {
  state = {
    new_purchase_order_num: '',
    isLoading: false,
  }

  render() {
    const poNums = this.props.selectedRows.map(row => row.PONum);
    return (
      <form style={styles.container}>
        {/* <h4>Location Change</h4> */}
        <div style={{ width: '100%', textAlign: 'center', height: '130px', fontSize: '15px', fontWeight: 'bold' }}>
          {
            !isGFD && <div style={{ display: 'flex', flexDirection: 'row', textAlign: 'center', justifyContent: 'center' }}>
            <div style={{ margin: '5px' }}><Translate value="new_po_num" />:</div>
            <div style={{ margin: '5px' }}>
              <input style={{ width: '100px', borderRadius: '5px', border: '1px solid black', padding: '0px 6px' }} onChange={e => this.setState({ new_purchase_order_num: e.target.value })} />
            </div>
          </div>
          }
          <p style={{ height: '90px', overflow: 'auto' }}>
            {poNums.join(',')}
          </p>
        </div>
        <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: '10px' }}>
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            onClick={() => {
              this.props.onClose()
            }}
          >
            <Translate value="cancel" />
          </Button>
          {this.state.isLoading && <Spinner />}
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            onClick={() => {
              this.setState({ isLoading: true });
              const poIds = this.props.selectedRows.map(row => row.id).join(',')
              const success = () => {
                this.props.handleMergePoSuccess();
                this.setState({ isLoading: false });
              };
              const failed = () => {
                this.setState({ isLoading: false });
              }
              let payload = {
                new_purchase_order_num: this.state.new_purchase_order_num || undefined,
              }
              if (isGFD) {
                payload = {}
              }
              mergePOAPI(poIds, payload, success, failed);
            }}
          >
            <Translate value="merge" />
          </Button>
        </div>
      </form>
    )
  }
}

const MergePOModal = ({ isVisible, onClose, onConfirm, selectedRows, handleMergePoSuccess }) => (
  <SkyLightStateless
    title={'Merge PO'}
    onCloseClicked={onClose}
    dialogStyles={modalStyle}
    isVisible={isVisible}
  >
    <POMerge selectedRows={selectedRows} onClose={onClose} onConfirm={onConfirm} handleMergePoSuccess={handleMergePoSuccess}/>
  </SkyLightStateless>
)

MergePOModal.propTypes = propTypes
MergePOModal.defaultProps = defaultProps

export default MergePOModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/purchaseManagement/MergePOModal.jsx